// extracted by mini-css-extract-plugin
export default {"auto_title":"index_auto_title_ImYim"};